import Navbar from '../navbar/Navbar'
import Footer from '../footer/Footer'
import './SeeBoard.scss'
import SeeBoard from './SeeBoard'

function Index() {
  return (
    <>
      <Navbar />
      <SeeBoard />
      <Footer />
    </>
  )
}

export default Index
